import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { refreshSession } from "./lib/api-client";
import { startSessionKeepalive } from "./lib/session-keepalive";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry once on failure — graceful for momentary network blips without
      // hammering the API on genuine 404s (fund not in DDB).
      retry: 1,
      // Don't refetch on window focus — fund data changes at most hourly.
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  // Keep the short-lived access cookie fresh on the gated dev/staging hosts by
  // proactively refreshing it before it expires (the edge gate can't refresh, so
  // a silent expiry would otherwise bounce an active user to login mid-session).
  // Prod web is OPEN (no session gate), so we must NOT pester /refresh there.
  useEffect(() => {
    if (import.meta.env.VITE_ENV === "production") return;
    return startSessionKeepalive(refreshSession);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
